import { Common } from "../../../utils";
import { axiosBasic } from "../../../api/axios";
import { config } from "../../../api/endPoints";
import { GET_CATEGORIES, IS_LOADING } from "./submitURLActionsTypes";

const { Categories, UserBookmarks } = config.REST_API;
const {ROOT_URL_Version_1,ROOT_URL}=config;
export const isLoading = value => ({
  type: IS_LOADING,
  payload: value
});

export const categoryLists = data => ({
  type: GET_CATEGORIES,
  payload: data
});

export const onGetCategories = () => dispatch => {
  dispatch(isLoading(true));
  axiosBasic
    .get(ROOT_URL+Categories.Get)
    .then(response => {
      const { success, data, message } = response.data;
      if (success) {
        const categories = [];
        categories.push(
          data.result.map(i => ({ key: i.Id, text: i.Name, value: i.Id }))
        );
        dispatch(categoryLists(categories));
      } else {
        Common.showErrorMessage(message);
      }
    })
    .catch(error => {
      Common.showErrorMessage(error);
    })
    .finally(() => {
      dispatch(isLoading(false));
    });
};

export const onSubmitBookmark = ({
  url,
  storyTitle,
  description,
  categoryId,
  navigation
}) => dispatch => {
  dispatch(isLoading(true));
  const descriptions = [{
    Description: description
  }];
  axiosBasic
    .post(ROOT_URL_Version_1+UserBookmarks.Post, {
      URL: url,
      StoryTitle: storyTitle,
      Descriptions: descriptions,
      CategoryId: categoryId,
      mobilePosted: 0
    })
    .then(response => {
      const { success, data, message } = response.data;
      if (success) {
        Common.showSuccessMessage(
          "Link submitted successfully. Download app to build more links on single click"
        );
        navigation.push("/more-bookmarks");
      } else {
        Common.showErrorMessage(message);
      }
    })
    .catch(error => {
      Common.showErrorMessage(error);
    })
    .finally(() => {
      dispatch(isLoading(false));
    });
};
